// Importing the necessary services

import { AgentService } from "./agent.service";
import { AnalysisService } from "./analysis.service";
import { DatasetFormulaeService } from "./datasetFormulae.service";
import { HammerService } from "./hammer.service";
import { LedgerService } from "./ledger.service";
import { LitheService } from "./lithes.services";
import { RealtimeService } from "./realtime.service";
import { SanitizationService } from "./sanitization.service";
import { TenantService } from "./tenant.service";
import { UserService } from "./user.service";

// Creating an object that holds instances of the services.
// This object will be used to access the services from the components.
export const services = {
	userServiceInstance: new UserService(), // Instance of UserService
	tenantServiceInstance: new TenantService(), // Instance of TenantService
	analysisServiceInstance: new AnalysisService(), // Instance of AnalysisService
	sanitizationService: new SanitizationService(), // Instance of SanitizationService
	litheService: new LitheService(), // Instance of LitheService
	hammerService: new HammerService(), // Instance of HammerService
	ledgerService: new LedgerService(), // Instance of LedgerService
	datasetFormulaeService: new DatasetFormulaeService(), // Instance of DatasetFormulaeService
	agentServiceInstance: new AgentService(), // Instance of AgentService
	realtimeServiceInstance: new RealtimeService(), // Instance of RealtimeService
};
